import { render } from "./RoleCreate.vue?vue&type=template&id=8a69dac4"
import script from "./RoleCreate.vue?vue&type=script&lang=js"
export * from "./RoleCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__